module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/brown-live-show-2edcf8eb8af271433acb2e26b4a9ae8e.gif";